import { ReplicatorStatus } from "../../models/ReplicatorStatus";
import { ArcGisToken } from "../../models/ArcGisToken";

// Constants
export const SET_SYNC_STATUS = "SET_SYNC_STATUS";
export const LOGOUT = "LOGOUT";
export const SET_ARCGIS_TOKEN = "SET_ARCGIS_TOKEN";
export const CLEAR_ARCGIS_TOKEN = "CLEAR_ARCGIS_TOKEN";

// State Type
export interface AppControlState {
    loading: boolean;
    currentSyncStatus: ReplicatorStatus;
    arcgisToken?: ArcGisToken;
}

// Action Types
interface SetSyncStatus {
    type: typeof SET_SYNC_STATUS;
    newStatus: ReplicatorStatus;
}

interface LogOutAction {
    type: typeof LOGOUT;
}

interface SetArcGISTokenAction {
    type: typeof SET_ARCGIS_TOKEN;
    token: ArcGisToken;
}

interface ClearArcGISTokenAction {
    type: typeof CLEAR_ARCGIS_TOKEN;
}

export type AppControlActionTypes = LogOutAction | SetSyncStatus | SetArcGISTokenAction | ClearArcGISTokenAction;
